export default "__VITE_ASSET__Cai$BmeT__"